<template>
  <div :class="['wrapper', classes]">
    <header class="main-header">
	<span class="logo-mini">
    <a href="/">
      <div class="img-responsive center-block logo"></div>
    </a>
	</span>
      <!-- Header Navbar -->
      <nav class="navbar navbar-static-top" role="navigation">
        <!-- Sidebar toggle button-->
        <a href="javascript:;" class="sidebar-toggle" data-toggle="offcanvas" role="button">
          <span class="sr-only">Toggle navigation</span>
        </a>
        <!-- Navbar Right Menu -->
        <div class="navbar-custom-menu">
          <ul class="nav navbar-nav">
  
            <!-- Notifications Menu -->
            <li class="dropdown notifications-menu">
              <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
                <i class="far fa-bell"></i>
                <span class="label label-danger">{{ notificationSize }}</span>
              </a>
              <ul class="dropdown-menu">
                <li class="header">You have {{ notificationSize }} notification(s)</li>
                <li v-if="notifications.length > 0">
                  <!-- Inner Menu: contains the notifications -->
                  <ul class="menu">
                    <li v-bind:key="notification._id" v-for="notification in notifications">
                      <!-- start notification -->
                      <router-link :to="{ name: 'Testimony', params: { id: notification._id }}">
                        <i class="fa fa-envelope text-wwow"></i> A new testimony has been reported
                      </router-link>
                    </li>
                    <!-- end notification -->
                  </ul>
                </li>
                <li class="footer" v-if="notifications.length > 0">
                  <a href="javascript:;">View all</a>
                </li>
              </ul>
            </li>

            <!-- User name and avatar image -->
            <li class="dropdown user user-menu">
              <p class="navbar-text">
                <img v-bind:src="demo.avatar" class="user-image" alt="User Image">
                <span v-if="user" class="hidden-xs">{{ user.displayName }}</span>
              </p>
            </li>
            <li>
              <!-- Logout -->
              <router-link :to="{ name: 'Login', query: { logout: 'yes' }}">
                <i class="fa fa-sign-out-alt"></i> Logout
              </router-link>
            </li>
          </ul>
        </div>
      </nav>
    </header>
    <!-- Left side column. contains the logo and sidebar -->
    <sidebar v-if="user" :role="user.role" :display-name="user.displayName" :picture-url="demo.avatar" />
  
    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <section class="content-header">
        <!-- <h1 > -->
          <!-- {{$route.name.toUpperCase() }} -->
          <!-- <small>{{ $route.meta.description }}</small> -->
        <!-- </h1> -->
        <div class="page-nav">
          <ul class="nav nav-tabs" v-if="$route.name === 'Testimony' || $route.name === 'TestimonyHistory'">
            <li class="nav-item" >
              <a class="nav-link page-nav-item" v-on:click="goTo('Testimony', $route.params.id)" v-bind:class="{'active' : $route.name === 'Testimony'}">
                <i class="ion ion-android-list"></i> Detail
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link page-nav-item" v-on:click="goTo('TestimonyHistory', $route.params.id)" v-bind:class="{'active' : $route.name === 'TestimonyHistory'}">
                <i class="ion ion-android-time"></i> History 
              </a>
            </li>
          </ul>
        </div>
        <ol class="breadcrumb">
          <li>
            <router-link :to="{ name : 'Dashboard' }">
              <i class="fa fa-home"></i> HOME
            </router-link>
          </li>
          <li class="active" v-if="$route.meta.parentName">
            <router-link :to="{ name : $route.meta.parentName }">
              {{ $route.meta.parentName.toUpperCase() }}
            </router-link>
          </li>
          <li class="active" v-if="$route.name !== 'Dashboard'">
            <router-link :to="{ name : $route.name }">
              {{ $route.name.toUpperCase() }}
            </router-link>
          </li>
        </ol>
      </section>
  
      <router-view></router-view>
    </div>
    <!-- /.content-wrapper -->
  </div>
  <!-- ./wrapper -->
</template>

<script>
// import faker from 'faker'
import jwtDecode from 'jwt-decode'
import { mapState } from 'vuex'
import config from '../config'
import Sidebar from './Sidebar'
import api from '../api'
import 'hideseek'
import moment from 'moment'

export default {
  name: 'Dash',
  components: {
    Sidebar
  },
  data: function () {
    return {
      // section: 'Dash',
      year: new Date().getFullYear(),
      classes: {
        fixed_layout: config.fixedLayout,
        hide_logo: config.hideLogoOnMobile
      },
      user: null,
      notifications: [],
      notificationSize: 0,
      error: '',
      timerId: 0
    }
  },
  computed: {
    ...mapState(['userInfo']),
    demo () {
      console.log('ROUTE', this.$route)
      return {
        avatar: require('./../assets/img/profile.png')
        // email: faker.internet.email(),
        // randomCard: faker.helpers.createCard()
      }
    }
  },
  methods: {
    changeloading () {
      this.$store.commit('TOGGLE_SEARCHING')
    },
    me () {
      return api.authenticatedRequest('get', '/users/me')
        .then(response => {
          this.user = {
            role: response.data.role,
            displayName: response.data.firstName + ' ' + response.data.lastName
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    getNotifications () {
      return api.authenticatedRequest('get', '/testimonies?unreadOnly=true')
        .then(response => {
          this.notifications = response.data.data
          this.notificationSize = response.data.total
        })
        .catch(error => {
          console.log(error)
        })
    },
    goTo (route, id) {
      this.$router.push({name: route, params: { id: id }})
    },
    checkTokenTTL () {
      try {
        const claims = jwtDecode(window.localStorage.getItem('token'))
        if (!moment(claims.exp * 1000).isAfter(moment(Date.now()))) {
          this.$router.push('/login')
        }
      } catch (e) {
        this.$router.push('/login')
      }
    }
  },
  mounted () {
    this.timerId = setInterval(() => {
      this.checkTokenTTL()
    }, 60000)
    this.$nextTick(() => {
      if (window.localStorage && window.localStorage.getItem('token')) {
        this.me()
        this.getNotifications()
      }
    })
  },
  destroyed () {
    clearInterval(this.timerId)
  }
}
</script>

<style lang='scss'>
.wrapper.fixed_layout {
  .main-header {
    position: fixed;
    width: 100%;
  }

  .content-wrapper {
    padding-top: 50px;
  }

  .main-sidebar {
    position: fixed;
    height: 100vh;
  }
}

.wrapper.hide_logo {
  @media (max-width: 767px) {
    .main-header .logo {
      display: none;
    }
  }
}

.logo-mini,
.logo-lg {
  text-align: left;

  div {
    background-color: #fff !important;
    background: url('/static/img/wwow-logo.png') no-repeat center;
    background-size: 80%;
  }
}

.logo-lg {
  div {
    display: -webkit-inline-box;
    width: 25%;
  }
}

.sidebar-collapse .logo-mini {
  div {
    background: url('/static/img/wwow-logo-min.png') no-repeat center;
    background-size: cover;
  }
}

.user-panel {
  height: 4em;
}

hr.visible-xs-block {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.17);
  height: 1px;
  border-color: transparent;
}

.page-nav {
  font-family: 'Raleway', sans-serif;
  min-height: 38px;
}

.page-nav-items {
  display: flex;
  padding-left: 15px;
}

.nav-link.page-nav-item {
  padding: 8px 40px;
  color: #444;
  background: #F5F4F4;
  border-color: #ddd;
  cursor: pointer;
}

.page-nav-item.active {
  background-color: #E14253;
  border-color: #DE2C3F;
  color: #fff;
  font-weight: 600;
  outline: none;
}

.page-nav-item:focus,
.page-nav-item:active:focus {
  outline: none !important;
}

.nav-item:first-child {
  margin-left: 30px;
}

.nav-tabs {
  margin: 0 -15px;
}

.page-nav-item.active:hover {
  opacity: 1 !important;
}

.page-nav-item:hover {
  background: #E14253 !important;
  border-color: #DE2C3F !important;
  color: #fff !important;
  opacity: 0.8;
  cursor: pointer;
}

.navbar p.navbar-text {
  color:#fff;
}
</style>



// WEBPACK FOOTER //
// Dash.vue?e9388dbc